import { Sparkle, Gift, Heart } from "../doodles/Doodles";

/**
 * TileImage — renders an admin-uploaded tile image or a doodle placeholder.
 *
 * Behaviour (fixes the "stale Unsplash flash" issue on slow networks):
 *  - If `loaded === true` AND `src` present → render the image
 *  - If `loaded === true` AND no `src` → render `fallback` (only reached when admin
 *    has never uploaded — this is the intentional design default, not a stale image)
 *  - If `loaded === false` (network still pending, no localStorage cache) → render
 *    a soft doodle skeleton so users NEVER see stock/stale images
 *
 * @param src     admin-uploaded URL (may be undefined until API responds)
 * @param loaded  boolean from useCategoryImages().loaded — whether API/cache is hydrated
 * @param fallback last-resort image if admin has intentionally left the tile empty
 * @param alt     alt text
 * @param className tailwind classes applied to the <img> (not the wrapper)
 * @param icon    optional doodle icon in the skeleton: "gift" | "heart" | "sparkle"
 */
export default function TileImage({ src, loaded, fallback, alt, className = "", icon = "gift" }) {
  if (!loaded) {
    const Icon = icon === "heart" ? Heart : icon === "sparkle" ? Sparkle : Gift;
    return (
      <div
        data-testid="tile-image-skeleton"
        className={`w-full h-full flex items-center justify-center bg-[#FFE7F1] animate-pulse ${className}`}
      >
        <Icon color="#7A1F2B" className="w-10 h-10 opacity-40" />
      </div>
    );
  }
  const finalSrc = src || fallback;
  if (!finalSrc) {
    return (
      <div className={`w-full h-full flex items-center justify-center bg-[#FFE7F1] ${className}`}>
        <Gift color="#7A1F2B" className="w-10 h-10 opacity-40" />
      </div>
    );
  }
  return <img src={finalSrc} alt={alt} className={className} loading="lazy" />;
}
